<template>
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 7C5.6875 7 6.25 6.4375 6.25 5.75C6.25 5.0625 5.6875 4.5 5 4.5C4.3125 4.5 3.75 5.0625 3.75 5.75C3.75 6.4375 4.3125 7 5 7ZM5 0.75C7.625 0.75 10 2.7625 10 5.875C10 7.8625 8.46875 10.2 5.4125 12.8938C5.175 13.1 4.81875 13.1 4.58125 12.8938C1.53125 10.2 0 7.8625 0 5.875C0 2.7625 2.375 0.75 5 0.75Z"
      fill="var(--primary-blue)"
    />
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
